import { render, staticRenderFns } from "./flightCard.vue?vue&type=template&id=bd07cf72&"
import script from "./flightCard.vue?vue&type=script&lang=js&"
export * from "./flightCard.vue?vue&type=script&lang=js&"
import style0 from "./flightCard.vue?vue&type=style&index=0&id=bd07cf72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports